import { put, takeLatest, call } from 'redux-saga/effects'
import { FORM_ERROR } from 'final-form'
import fetchFromAPI, { getDefaultHeaders } from 'helpers/fetchFromApi'
import decodeJWT from 'helpers/decodeJWT'
import NoticeHelper from 'helpers/notice'
import * as ROUTE from 'constants/apiRouting'
import {
  LOGIN,
  LOGIN_GOOGLE,
  LOGIN_MICROSOFT,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAILURE,
  RECOVERY_PASSWORD,
  RECOVERY_PASSWORD_SUCCESS,
  RECOVERY_PASSWORD_FAILURE,
  RESET_TOKEN_EXIST,
  RESET_TOKEN_EXIST_SUCCESS,
  RESET_TOKEN_EXIST_FAILURE,
} from './reducer'
import { SET_JWT_DATA } from '../profile/reducer'
import { SHOW_NOTICE } from '../notice'

function* loginWithOAuth(action) {
  const { payload, promise } = action

  try {
    const response = yield call(fetchFromAPI, {
      data: payload,
      headers: getDefaultHeaders(),
      method: 'POST',
      partUrl: ROUTE.LOGIN_OAUTH,
    })

    if (response && !response.error) {
      localStorage.setItem('token', response.token)
      localStorage.setItem('refresh_token', response.refresh_token)
      yield put({ type: SET_JWT_DATA, payload: decodeJWT(response.token) })
      yield put({ type: LOGIN_SUCCESS })
    } else {
      if (response.message && response.message !== '') {
        yield put({
          type: SHOW_NOTICE,
          notice: NoticeHelper.createErrorObj(response.message),
        })
      }
      yield put({ type: LOGIN_FAILURE, error: response.errors })
      yield call(promise.resolve, {
        error: true,
        [FORM_ERROR]: response.errors,
        errorString: response.errors,
      })
    }
  } catch (error) {
    yield put({ type: LOGIN_FAILURE, error: error.toString() })
  }
}

function* login(action) {
  const { payload, promise } = action

  try {
    const response = yield call(fetchFromAPI, {
      data: payload,
      headers: getDefaultHeaders(),
      method: 'POST',
      partUrl: ROUTE.LOGIN,
    })

    if (!response || !response.error) {
      localStorage.setItem('token', response.token)
      localStorage.setItem('refresh_token', response.refresh_token)
      yield put({ type: SET_JWT_DATA, payload: decodeJWT(response.token) })
      yield put({ type: LOGIN_SUCCESS })
    } else {
      if (response.message && response.message !== '') {
        yield put({
          type: SHOW_NOTICE,
          notice: NoticeHelper.createErrorObj(response.message),
        })
      }
      yield put({ type: LOGIN_FAILURE, error: response.errors })
      yield call(promise.resolve, {
        error: true,
        [FORM_ERROR]: response.errors,
        errorString: response.errors,
      })
    }
  } catch (error) {
    yield put({ type: LOGIN_FAILURE, error: error.toString() })
    yield call(promise.resolve, {
      error: true,
      [FORM_ERROR]: error.toString(),
      errorString: error.toString(),
    })
  }
}

function* forgotPassword(action) {
  const { payload, promise } = action

  try {
    const value = yield call(fetchFromAPI, {
      data: payload,
      headers: getDefaultHeaders(),
      method: 'POST',
      partUrl: ROUTE.FORGOT_PASSWORD,
    })

    if (!value || !value.error) {
      yield put({ type: FORGOT_PASSWORD_SUCCESS })
      yield call(promise.resolve)
    } else {
      yield put({ type: FORGOT_PASSWORD_FAILURE, error: value.errors })
      yield call(promise.resolve, {
        error: true,
        [FORM_ERROR]: value.errors,
        errorString: value.errors,
      })
    }
  } catch (error) {
    yield put({ type: FORGOT_PASSWORD_FAILURE, error: error.toString() })
    yield call(promise.resolve, {
      error: true,
      [FORM_ERROR]: error.toString(),
      errorString: error.toString(),
    })
  }
}

function* recoveryPassword(action) {
  const {
    payload: { reset_token, ...data },
    promise,
  } = action

  try {
    const value = yield call(fetchFromAPI, {
      data,
      headers: getDefaultHeaders(),
      method: 'POST',
      partUrl: `${ROUTE.RESET_PASSWORD}${reset_token}`,
    })

    if (!value || !value.error) {
      yield put({ type: RECOVERY_PASSWORD_SUCCESS })
      yield call(promise.resolve)
    } else {
      yield put({ type: RECOVERY_PASSWORD_FAILURE, error: value.errors })
      yield call(promise.resolve, {
        error: true,
        [FORM_ERROR]: value.errors,
        errorString: value.errors,
      })
    }
  } catch (error) {
    yield put({ type: RECOVERY_PASSWORD_FAILURE, error: error.toString() })
    yield call(promise.resolve, {
      error: true,
      [FORM_ERROR]: error.toString(),
      errorString: error.toString(),
    })
  }
}

function* checkResetTokenExist(action) {
  const {
    payload: { reset_token },
  } = action

  try {
    const value = yield call(fetchFromAPI, {
      headers: getDefaultHeaders(),
      partUrl: `${ROUTE.RESET_TOKEN}${reset_token}`,
    })

    if (!value || !value.error) {
      yield put({ type: RESET_TOKEN_EXIST_SUCCESS, payload: value.exist })
    } else {
      yield put({ type: RESET_TOKEN_EXIST_FAILURE, error: value.errors })
    }
  } catch (error) {
    yield put({ type: RESET_TOKEN_EXIST_FAILURE, error: error.toString() })
  }
}

function* authSaga() {
  yield takeLatest(LOGIN, login)
  yield takeLatest(LOGIN_GOOGLE, loginWithOAuth)
  yield takeLatest(LOGIN_MICROSOFT, loginWithOAuth)
  yield takeLatest(FORGOT_PASSWORD, forgotPassword)
  yield takeLatest(RECOVERY_PASSWORD, recoveryPassword)
  yield takeLatest(RESET_TOKEN_EXIST, checkResetTokenExist)
}

export default authSaga
